import React from "react";
import { useTranslation } from "react-i18next";
import "./styles/Services.css";
import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function Qml3DDrawing() {
    const { t } = useTranslation();

    return (
        <div className="service-page">
            <SEO
                title={t('qml3d.seo_title')}
                description={t('qml3d.seo_desc')}
                keywords={t('qml3d.seo_keywords')}
                url="/qml-3d-drawing"
                schemaType="service"
            />
            <TitleFragment title={t('qml3d.page_title')} />

            <div className="service-container">
                <p className="service-intro-text" style={{ textAlign: 'center', fontSize: '1.4rem', fontWeight: '500', marginTop: '2rem', marginBottom: '1rem' }}>
                    {t('qml3d.subtitle')}
                </p>

                <section className="service-section">
                    <p className="service-intro-text">
                        {t('qml3d.intro')}
                    </p>
                </section>

                <section className="service-section">
                    <h2>{t('qml3d.what_we_offer')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h3>{t('qml3d.prebuilt_title')}</h3>
                            <p>{t('qml3d.prebuilt_desc')}</p>
                            <ul>
                                <li>{t('qml3d.prebuilt_li1')}</li>
                                <li>{t('qml3d.prebuilt_li2')}</li>
                                <li>{t('qml3d.prebuilt_li3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h3>{t('qml3d.custom_title')}</h3>
                            <p>{t('qml3d.custom_desc')}</p>
                            <ul>
                                <li>{t('qml3d.custom_li1')}</li>
                                <li>{t('qml3d.custom_li2')}</li>
                                <li>{t('qml3d.custom_li3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h3>{t('qml3d.optimized_title')}</h3>
                            <p>{t('qml3d.optimized_desc')}</p>
                            <ul>
                                <li>{t('qml3d.optimized_li1')}</li>
                                <li>{t('qml3d.optimized_li2')}</li>
                                <li>{t('qml3d.optimized_li3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h3>{t('qml3d.cross_title')}</h3>
                            <p>{t('qml3d.cross_desc')}</p>
                            <ul>
                                <li>{t('qml3d.cross_li1')}</li>
                                <li>{t('qml3d.cross_li2')}</li>
                                <li>{t('qml3d.cross_li3')}</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qml3d.features_title')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h4>{t('qml3d.feat_lighting_title')}</h4>
                            <p>{t('qml3d.feat_lighting_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('qml3d.feat_unified_title')}</h4>
                            <p>{t('qml3d.feat_unified_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('qml3d.feat_anim_title')}</h4>
                            <p>{t('qml3d.feat_anim_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('qml3d.feat_rapid_title')}</h4>
                            <p>{t('qml3d.feat_rapid_desc')}</p>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qml3d.use_cases_title')}</h2>
                    <div className="service-feature-list">
                        <div className="service-feature-item">{t('qml3d.uc_auto')}</div>
                        <div className="service-feature-item">{t('qml3d.uc_ind')}</div>
                        <div className="service-feature-item">{t('qml3d.uc_med')}</div>
                        <div className="service-feature-item">{t('qml3d.uc_smart')}</div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Qml3DDrawing;
